import React from 'react';

import { hexToRgba } from './dashboardTitles';

const RADIAN = Math.PI / 180;
const BADGE_DISTANCE = 100;

export default function DonutSliceBadge({
  cx,
  cy,
  midAngle,
  value,
  fill,
  payload,
}) {
  if (cx == null || cy == null || midAngle == null || value == null) {
    return null;
  }

  const x = cx + BADGE_DISTANCE * Math.cos(-midAngle * RADIAN);
  const y = cy + BADGE_DISTANCE * Math.sin(-midAngle * RADIAN);
  const isMuted = payload?.label === 'Autre' || payload?.label === 'Non renseigné';

  return (
    <g>
      <circle cx={x} cy={y} r={15} fill={hexToRgba(fill || '#DADADF', isMuted ? 0.9 : 0.35)} />
      <text
        x={x}
        y={y}
        textAnchor="middle"
        dominantBaseline="central"
        fill="#192243"
        style={{ fontFamily: 'Anybody-SemiBold', fontSize: 18 }}
      >
        {value}
      </text>
    </g>
  );
}
